/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

import { getApi, putApi, postApi } from 'lib/axios';
import { BASE_URL } from 'utils/const';

import { enqueueSnackbar } from './notificationSlice';

/**
 * 出品者を全件取得する
 */
export const fetchAllExhibitors = createAsyncThunk(
  'requests/fetchAllExhibitors',
  async (data, { dispatch }) => {
    const param = data?.isForProductDetail
      ? {
          per_page: data?.rowsPerPage || 100,
          page: data?.page || 1,
        }
      : {
          per_page: data?.rowsPerPage,
          page: data?.page,
          exhibitor_name: data?.name,
          tel: data?.tel,
          franchisee_code: data?.franchiseeCode,
          prefecture_id: !data?.address || data?.address === '0' ? null : Number(data?.address),
          exhibitor_type_atrs: data?.atrs === 'true' ? 1 : 0,
          exhibitor_type_rebuild: data?.rebuild === 'true' ? 1 : 0,
          exhibitor_type_partsone: data?.partsone === 'true' ? 1 : 0,
          transaction_status_dealing: data?.trading === 'true' ? 1 : 0,
          transaction_status_cancelled: data?.cancel === 'true' ? 1 : 0,
        };

    try {
      const res = await getApi(`${BASE_URL}/exhibitor`, param);

      return res;
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: 'エラーが発生しました。',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'error',
          },
        }),
      );
      throw error;
    }
  },
);

/**
 * 出品者を取得する
 */
export const fetchExhibitor = createAsyncThunk(
  'requests/fetchExhibitor',
  async (id, { dispatch }) => {
    try {
      const res = await getApi(`${BASE_URL}/exhibitor/${id}`);

      console.log('requestAPI : 接続', res);

      return res;
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: 'エラーが発生しました。',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'error',
          },
        }),
      );
      throw error;
    }
  },
);

/**
 * 出品者を更新する
 */
export const updateExhibitor = createAsyncThunk(
  'requests/updateExhibitor',
  async (param, { dispatch }) => {
    try {
      const body = {
        exhibitor_name: param.name,
        tel: param.tel,
        is_dealing: param.isDealing,
        franchisee_code: param.franchiseeCode,
        exhibitor_type: param.exhibitorType,
        prefecture_id: param.prefecture,
        shipping_cutoff_time: param.date,
        s_size_deliverer: param.sSizeDeliverer,
        m_size_deliverer: param.mSizeDeliverer,
        l_size_deliverer: param.lSizeDeliverer,
        s_size_deliverer_cutoff_time: param.sSizeDelivererCutoffTime,
        m_size_deliverer_cutoff_time: param.mSizeDelivererCutoffTime,
        l_size_deliverer_cutoff_time: param.lSizeDelivererCutoffTime,
        admin_memo: param.adminMemo,
      };

      console.log('requestAPI', body);

      const res = await putApi(`${BASE_URL}/exhibitor/${param.exhibitorId}`, body);

      console.log('responseAPI', res);

      dispatch(
        enqueueSnackbar({
          message: '出品者情報を更新しました。',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'success',
          },
        }),
      );

      return {
        id: param.exhibitorId,
        order: res.data,
      };
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: 'エラーが発生しました。',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'error',
          },
        }),
      );

      throw error;
    }
  },
);

/**
 * 出品者を登録する
 */
export const createExhibitor = createAsyncThunk(
  'exhibitors/createExhibitor',
  async (param, { dispatch }) => {
    try {
      const body = {
        exhibitor_name: param.name,
        tel: param.tel,
        is_dealing: param.isDealing,
        franchisee_code: param.franchiseeCode,
        exhibitor_type: param.exhibitorType,
        prefecture_id: param.prefecture,
        shipping_cutoff_time: param.date,
        s_size_deliverer: param.sSizeDeliverer,
        m_size_deliverer: param.mSizeDeliverer,
        l_size_deliverer: param.lSizeDeliverer,
        s_size_deliverer_cutoff_time: param.sSizeDelivererCutoffTime,
        m_size_deliverer_cutoff_time: param.mSizeDelivererCutoffTime,
        l_size_deliverer_cutoff_time: param.lSizeDelivererCutoffTime,
        admin_memo: param.adminMemo,
      };

      console.log('requestAPI', body);

      const res = await postApi(`${BASE_URL}/exhibitor`, body);

      console.log('responseAPI', res);

      dispatch(
        enqueueSnackbar({
          message: '出品者情報を登録しました。',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'success',
          },
        }),
      );

      return {
        id: param.exhibitorId,
        request: param,
      };
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: 'エラーが発生しました。',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'error',
          },
        }),
      );

      throw error;
    }
  },
);

const exhibitorsAdapter = createEntityAdapter({
  selectId: (e) => e.exhibitor_id,
});

export const exhibitorSlice = createSlice({
  name: 'exhibitor',
  initialState: exhibitorsAdapter.getInitialState({
    loading: true,
  }),
  reducers: {
    addTag: exhibitorsAdapter.addOne,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllExhibitors.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAllExhibitors.fulfilled, (state, action) => {
      exhibitorsAdapter.setAll(state, action.payload.data);
      state.loading = false;
    });
    builder.addCase(fetchAllExhibitors.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(fetchExhibitor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchExhibitor.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(fetchExhibitor.fulfilled, (state, action) => {
      exhibitorsAdapter.upsertOne(state, action.payload.data);
      state.loading = false;
    });
    builder.addCase(updateExhibitor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateExhibitor.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(updateExhibitor.fulfilled, (state, action) => {
      exhibitorsAdapter.updateOne(state, {
        id: action.payload.id,
        changes: { ...action.payload.request },
      });
      state.loading = false;
    });
    builder.addCase(createExhibitor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createExhibitor.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(createExhibitor.fulfilled, (state, action) => {
      exhibitorsAdapter.addOne(state, {
        id: action.payload.id,
        changes: { ...action.payload.request },
      });
      state.loading = false;
    });
  },
});

export const exhibitorSelectors = exhibitorsAdapter.getSelectors((state) => state.exhibitors);

export default exhibitorSlice.reducer;
